import {makeActionCreator} from '../utility'

export const FETCH_EVENTS = 'FETCH_EVENTS'
export const fetchEvents = makeActionCreator(FETCH_EVENTS,'data')


export const FETCH_EVENTS_SUCCESSFUL = 'FETCH_EVENTS_SUCCESSFUL'
export const  fetchEventsSuccessful= makeActionCreator(FETCH_EVENTS_SUCCESSFUL, 'data')